/**
 * @generated SignedSource<<aae0c2d32021fbae458947d25e290176>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActionsSetUpPanes_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaneReducer_buyer">;
  readonly " $fragmentType": "checkoutSetUpActionsSetUpPanes_buyer";
};
export type checkoutSetUpActionsSetUpPanes_buyer$key = {
  readonly " $data"?: checkoutSetUpActionsSetUpPanes_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActionsSetUpPanes_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActionsSetUpPanes_buyer"
};

(node as any).hash = "922f4289e3937e98f3e09f32c97cc787";

export default node;
